import axiosClient from "./axiosClient";

// Matches AboutUsMediaType on the API (enums are serialized as numbers).
export const AboutUsMediaType = {
  Image: 1,
  Video: 2,
};

export async function getAboutUsPosts() {
  const response = await axiosClient.get("/aboutus/posts");
  return response.data;
}

// Uploads every file of one post in a single request. Videos can be large, so the
// default 30s client timeout is lifted and progress (0..1) is reported instead.
export async function createAboutUsPost(files, caption, onProgress) {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));
  if (caption) formData.append("caption", caption);
  const response = await axiosClient.post("/aboutus/posts", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 0,
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(e.loaded / e.total);
    },
  });
  return response.data;
}

export async function updateAboutUsPost(id, caption) {
  const response = await axiosClient.put(`/aboutus/posts/${id}`, { caption });
  return response.data;
}

export async function reorderAboutUsPosts(postIds) {
  await axiosClient.put("/aboutus/posts/order", { postIds });
}

export async function deleteAboutUsPost(id) {
  await axiosClient.delete(`/aboutus/posts/${id}`);
}
